jQuery(function () {

    jQuery('body').on('change', '.tabs__select', function () {
        var $this = jQuery(this);
        var $container = jQuery(this).closest(".tabs__container");
        var all_tab_contents = $container.find('.js-tabcontent');

        jQuery('.js-tablist__item').each(function (index, element) {
            jQuery(element).removeClass('js-tablist__item--active');
        });

        window.location.hash = '#' + $this.val();

        jQuery(all_tab_contents).each(function (index, element) {
            var $panel = jQuery(element);
            $panel.attr("aria-hidden", "true");
            if ($panel.attr('id') == $this.val()) {
                $panel.attr("aria-hidden", "false");
                jQuery('#js-tablist__item-' + $this.val()).addClass('js-tablist__item--active');
            }
        });

        return false;
    });


    if (window.location.hash) {
        var hash = window.location.hash.substring(1);
        jQuery('.tabs__select').val(hash);
    }


    jQuery('body').on('change', '.tabs-nav__select', function (e) {
        var $this = jQuery(this);

        if ($this.hasClass('tabs-nav__select--pjax')) {
            var $option = $this.find(':selected');
            var $container = jQuery('#pjax-container');
            var fragment = jQuery("#pjax-container");


            $container.addClass('pjax-container--hide');
            jQuery(document).one('pjax:complete', function () {
                $container.removeClass('pjax-container--hide');
            });


            $container.one('transitionend oTransitionEnd', function () {
                jQuery.pjax({
                    container: '#pjax-container',
                    fragment: '#pjax-container',
                    scrollTo: false,
                    url: $this.val()
                });


            });
            return false;

        } else {
            window.location = $this.val();
        }

        return false;
    });

    // * ---------------------------------
    // * NCC-547, NCC-1098 | Tabs and Select - <START

    // ? clean path of defined directory
    function cleanUrlPath(path, dir) {
        if (path.search(dir) !== -1) {
            path = path.replace(dir, '/');
            path = path.toString().toLowerCase();
            //console.log(path);
            return path;
        }
        return path;
    }

    // ? check if it exists in the path for articles
    function existsInPath(value, path) {
        var regexPath = new RegExp(value, "gi");
        var path = path.match(regexPath);
        if (path != null) {
            return true;
        }
    }

    var $path = window.location.pathname;
    var $href;
    var $value;
    var isBlog = false;
    var noMatch = 0;
    var numoptions = jQuery('.tabs-nav__select option').length;

    // ? clean path
    $path = $path.toString().toLowerCase();
    $path = cleanUrlPath($path, '/en/');

    // ? select option
    jQuery('.tabs-nav__select').val($path);

    // ? on load select option (mobile)
    jQuery('.tabs-nav__select option').each(function (index, ele) {
        // ? get option values for matching
        $value = jQuery(this).attr('value').toLowerCase();
        $value = cleanUrlPath($value, '/en/');

        // ? check if path and value match
        // console.log('path:' + $path+ ' value:'+ $value);
        if ($value == $path || existsInPath($value, $path)) {
            jQuery(this).prop('selected', true);
        } else {
            noMatch++;
        }

        // ? if the paths never match and 'blog' string exist in path, then it is the blog page
        if (noMatch == numoptions && existsInPath('blog', $path)) {
            isBlog = true;
        }

    });

    // ? check if path and value match
    if (isBlog) {
        jQuery('.tabs-nav__select').prepend('<option selected="true">Select a section</option>')
    }

    // ? on load select tab (desktop)
    jQuery('.tabs-nav__link').each(function (index, ele) {

        $href = jQuery(ele).attr('href');
        var isDesktop = window.matchMedia("(min-width: 768px)").matches;

        // ? clean paths
        $href = cleanUrlPath($href, '/en/');
        $href = cleanUrlPath($href, '/Blog/');
        if ( $href == $path ) {
            jQuery(ele).addClass('tabs-nav__link--active');
        }

    });

    // * NCC-547 - Tabs and Select - END>
    // * ---------------------------------

    // * NCC-547 - On pjax:success
    jQuery(document).on('pjax:complete ', function (event) {
        $path = window.location.pathname;
        $path.toString();
        //var $page_url = window.location.pathname;
        var $url = $path.substr($path.lastIndexOf('/') + 1);
        //console.log("complete 1");


        jQuery('.tabs-nav__link').removeClass('tabs-nav__link--active');
        jQuery('.tabs-nav__link').each(function (index, ele) {
            var $link_path_full = jQuery(this).attr("href");
            var $link_path = $link_path_full.substr($link_path_full.lastIndexOf('/') + 1);
            if ($link_path == $url) {
                //console.log("complete 2");
                jQuery(ele).addClass('tabs-nav__link--active');
            }
        });

        // * NCC-547 - the selected option
        jQuery('.tabs-nav__select').val($path);

        // * NCC-547 - get option crumb data and apply it to breadcrumb
        jQuery('.tabs-nav__select option').each(function () {
            //For Mobile
            var $link_path_full = jQuery(this).val();
            var $link_path = $link_path_full.substr($link_path_full.lastIndexOf('/') + 1);
                if($link_path == $url){
                    jQuery(this).prop("selected", true);

                    //For breadcrumb
                    var newCrumb = jQuery(this).data('crumb');
                    jQuery('.breadcrumb__content--js-replace').text(newCrumb);
                }
        });

    });

    jQuery(document).on('click', 'a[data-pjax]', function (e) {
        jquery_accessible_tabs();


        var $this = jQuery(this);
        var fragment = $this.data('fragment');
        var container = $this.data('container');
        var $container = jQuery(container);
        var event = e;
        var $replace = jQuery('.breadcrumb__content--js-replace');
        var newCrumb = $this.data('crumb');

        // Change active link
        jQuery('.tabs-nav__link').removeClass('tabs-nav__link--active');
        $this.addClass('tabs-nav__link--active');
        $container.addClass('pjax-container--hide');

        jQuery(document).one('pjax:complete', function () {
            $container.removeClass('pjax-container--hide');
        });


        $container.one('transitionend oTransitionEnd', function (e) {
            jQuery.pjax({
                container: container,
                fragment: fragment,
                scrollTo: false,
                url: $this.attr('href')
            });


        });

        // if (newCrumb) {
        $container.one('pjax:success', function () {

            // If there is a tabs container within the pjax container, we need to re-init the accessible tabs
            var $tabs = $container.find('.js-tabs');
            if ($tabs.length > 0) {
                jquery_accessible_tabs();
                $panels = $tabs.find('.js-tabcontent.tabs__content');

                if ($panels.length > 0) {
                    jQuery($panels[0]).attr('aria-hidden', false);
                }
            }

            if (newCrumb) {
                var $select = $this.closest('.tabs-nav').find('.tabs-nav__select');
                $select.val($this.attr('href'));
                $replace.text(newCrumb);
            }

        });
        // }


        return false;

    });


    //Browser back forward button
    jQuery(window).on('popstate', function(event) {
            var $page_url = window.location.pathname;
            var $url = $page_url.substr($page_url.lastIndexOf('/') + 1);
                //For Desktop
                jQuery(".tabs-nav__link").each(function(){
                    var $link_path_full = jQuery(this).attr("href");
                    var $link_path = $link_path_full.substr($link_path_full.lastIndexOf('/') + 1);
                        jQuery(this).removeClass("tabs-nav__link--active");
                        if($link_path == $url){
                            jQuery(this).addClass("tabs-nav__link--active");
                        }
                });
                //For Mobile
                jQuery(".tabs-nav__select option").each(function(){
                    var $link_path_full = jQuery(this).val();
                    var $link_path = $link_path_full.substr($link_path_full.lastIndexOf('/') + 1);
                        if($link_path == $url){
                            jQuery(this).prop("selected", true);
                        }
                });

                //Breadcrumb

                if(jQuery(".tabs-nav__select").is(":visible")){
                jQuery(".breadcrumb__content--js-replace").text(jQuery(".tabs-nav__select option:selected").data("crumb"));
                }
                else{
                jQuery(".breadcrumb__content--js-replace").text(jQuery(".tabs-nav__link--active").data("crumb"));
                }

    });

    //Tab jumps in mobile fix
    jQuery(".tabs__select").change(function () {
        jQuery('html, body').animate({
            scrollTop: jQuery(".tabs__container").offset().top
        }, 500);
    });

});
